import "./p5.css";

export const FONT = "Courier New";
export const DEFAULT_MAPPING = "codingTrain";
export const DENSITY_MAPPINGS = {
  codingTrain: {
    alphabet: "Ñ@#W$9876543210?!abc;:+=-,._                ",
    flip: true,
  },
  farsiCustom: {
    alphabet: "ةممعدپیبنهوتثجحخچصضسشذلرزژةعغفقغفقطظکگ",
    flip: false,
  },
  farsiAlphabet: {
    alphabet: "ػؼڴڟڱؿڦڰڤڞڭظؾګگڲڳشؽڜطفٿڣڬضکثك٪ٹټٽښڡڢڥڪڮڷصڝتسٺڅڐڛڠڨڿئٷٸڵقمځڂچڇڈڋڎڏڶبةخل٣٨٩ٮٻپڀڃڄڌڧڸڻڽؤجغىي٢٤ٶڙحذٯٲژڹآأعن٦ٱٵډڑڼدـڊڍڗوڒںإزٳږرړڔڕ",
    flip: false,
  }
};

// From https://stackoverflow.com/questions/66181450/javascript-get-brightness-of-single-character
export function getAlphabetBrightnessOrdering(alphabet) {
  const BG_COLOR = "white";
  const CHAR_COLOR = "black";
  const width = 30;
  const height = 32;

  const tag = (tag, props = {}) =>
    Object.assign(document.createElement(tag), props);
  const sC2Lin = (val) => {
    val /= 255;
    return val <= 0.04045 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  };
  const RGB2Gama = (r, g, b) => {
    return sC2Lin(r) * 0.212655 + sC2Lin(g) * 0.715158 + sC2Lin(b) * 0.072187;
  };

  function charBrightness(ctx, char, color = CHAR_COLOR, bgColor = BG_COLOR) {
    ctx.font = `38px ${FONT}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = color;
    ctx.fillText(char, width / 2, height * (1.9 / 3));
    const d = ctx.getImageData(0, 0, width, height).data;

    var bSum = 0,
      i = 0;
    while (i < d.length) {
      bSum += RGB2Gama(d[i++], d[i++], d[i++]);
      i++;
    }
    const meanGam = bSum / (d.length / 4);
    return (
      (meanGam <= 0.0031308
        ? meanGam * 12.92
        : 1.055 * meanGam ** (1 / 2.4) - 0.055) * 255
    );
  }
  function getCharBrightness(char) {
    const canvas = tag("canvas", { width, height });
    const context = canvas.getContext("2d");

    const bright = Math.round(charBrightness(context, char));
    return bright;
  }

  const alphabetWithBrightness = {};
  alphabet.forEach((c) => {
    alphabetWithBrightness[c] = getCharBrightness(c);
  });

  // Create items array
  var items = Object.keys(alphabetWithBrightness).map(function (key) {
    return [key, alphabetWithBrightness[key]];
  });

  // Sort the array based on the second element
  items.sort(function (first, second) {
    return second[1] - first[1];
  });

  return items.map((item) => item[0]).join('');
}

export const PERSIAN_ALPHABET = [
  "آ",
  "أ",
  "ؤ",
  "إ",
  "ئ",
  "ب",
  "ة",
  "ت",
  "ث",
  "ج",
  "ح",
  "خ",
  "د",
  "ذ",
  "ر",
  "ز",
  "س",
  "ش",
  "ص",
  "ض",
  "ط",
  "ظ",
  "ع",
  "غ",
  "ػ",
  "ؼ",
  "ؽ",
  "ؾ",
  "ؿ",
  "ـ",
  "ف",
  "ق",
  "ك",
  "ل",
  "م",
  "ن",
  "و",
  "ى",
  "ي",
  "٢",
  "٣",
  "٤",
  "٦",
  "٨",
  "٩",
  "٪",
  "ٮ",
  "ٯ",
  "ٱ",
  "ٲ",
  "ٳ",
  "ٵ",
  "ٶ",
  "ٷ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  " ",
  "ٸ",
  "ٹ",
  "ٺ",
  "ٻ",
  "ټ",
  "ٽ",
  "پ",
  "ٿ",
  "ڀ",
  "ځ",
  "ڂ",
  "ڃ",
  "ڄ",
  "څ",
  "چ",
  "ڇ",
  "ڈ",
  "ډ",
  "ڊ",
  "ڋ",
  "ڌ",
  "ڍ",
  "ڎ",
  "ڏ",
  "ڐ",
  "ڑ",
  "ڒ",
  "ړ",
  "ڔ",
  "ڕ",
  "ږ",
  "ڗ",
  "ژ",
  "ڙ",
  "ښ",
  "ڛ",
  "ڜ",
  "ڝ",
  "ڞ",
  "ڟ",
  "ڠ",
  "ڡ",
  "ڢ",
  "ڣ",
  "ڤ",
  "ڥ",
  "ڦ",
  "ڧ",
  "ڨ",
  "ک",
  "ڪ",
  "ګ",
  "ڬ",
  "ڭ",
  "ڮ",
  "گ",
  "ڰ",
  "ڱ",
  "ڲ",
  "ڳ",
  "ڴ",
  "ڵ",
  "ڶ",
  "ڷ",
  "ڸ",
  "ڹ",
  "ں",
  "ڻ",
  "ڼ",
  "ڽ",
  "ڿ",
];
